import React, { useEffect } from "react";
import { _goToCart, _openDrawer } from "router/helper";
import { useIsFocused } from "@react-navigation/native";

import { View, TouchableOpacity } from "react-native";
import { Text, Button, HeaderLayout, Img } from "component";

import { colors, sizes, strings } from "asset/constant";
import { useRecoilValue } from "recoil";
import { cartAtom } from "store";
import { css } from "style";

import { useCart } from "client/api";
import { sn } from "utils";
import { logo } from "asset/logo";

export default function HomeHeader() {
  const cart = useRecoilValue(cartAtom);

  const isFocused = useIsFocused();
  const { refetch } = useCart();
  useEffect(() => {
    isFocused && refetch();
  }, [isFocused, refetch]);

  return (
    <HeaderLayout>
      <View style={[css.rRowContainerCenterElements]}>
        <View style={css.rRowContainerCenterAlign}>
          {sn(true, true, true, false) && (
            <Button
              onPress={_openDrawer}
              bgColor={colors.white}
              circle={40}
              icon={{
                size: 22,
                type: "oct",
                name: "three-bars",
                color: colors.theme,
              }}
            />
          )}

          <View>
            <Img
              source={logo.entries_screens}
              style={{
                alignSelf: "flex-end",
                width: 70,
                height: 70 / 3.16,
              }}
            />
            <Text weight="extraBold" size={"sm"}>
              {strings.submit_order_system}
            </Text>
          </View>
        </View>
        <View style={[css.centralElContainer]}>
          <Text size={"xxl"} weight="black" color={colors.white}>
            {strings.app_name}
          </Text>
        </View>
        <View>
          <Button
            bgColor="transparent"
            square={45}
            onPress={_goToCart}
            icon={{ name: "shoppingcart", size: 27, color: colors.theme }}
          />
          {cart && cart?.products?.length > 0 && (
            <TouchableOpacity
              onPress={_goToCart}
              activeOpacity={sizes.tapOpacity}
              style={{
                ...css.fix,
                top: -3,
                right: 0,
                height: 19,
                minWidth: 19,
                paddingHorizontal: 5,
                backgroundColor: colors.white,
                borderRadius: sizes.radius.lg,
              }}
            >
              <View
                style={{
                  minWidth: 20,
                  minHeight: 20,
                  borderWidth: 1,
                  borderRadius: 20,
                  backgroundColor: colors.white,
                  borderColor: colors.black + "33",
                  ...css.centralElements,
                  ...css.shadowForWeb(10),
                }}
              >
                <Text
                  style={{ bottom: 2 }}
                  color={colors.theme}
                  weight="extraBold"
                >
                  {cart?.products?.reduce((sum, p) => sum + Number(p.count), 0)}
                </Text>
              </View>
            </TouchableOpacity>
          )}
        </View>
      </View>
    </HeaderLayout>
  );
}
